<!-- 图书柜-我要买书-支付列表(包含扫描条码) -->
<template>
  <div class="BookcaseBScanCode">
    
    <!-- 预定商品列表 -->
    <div class="reserve-wrapper" v-if="hasReserveList">
      <div class="list-tit">预约商品</div>
      <div class="reserve-box">
        <div class="list" v-for="(item, index) in reserveList" :key="index">
          <img class="cover" :src="item.image" alt="" />
          <p class="bookname">{{item.name}}</p>
          <p class="num">编号： {{item.pid}}</p>
        </div>
      </div>
    </div>

    <div class="list-tit two">选购商品</div>
    <!-- 扫描条码 -->
    <div class="box" v-if="isScanCodePage">
      <img class="icon" src="/static/Bookcase/images/icon_scan.png" alt="">
      <p class="text">已为您打开{{$store.state.ECMall_activeGoods.gridno}}号箱格</p>
      <p class="hint">请在扫码枪上扫描商品背面身份码查看价格</p>
    </div>
    
    <!-- 选购商品列表（待支付） -->
    <template v-else>
      <div class="list-wrapper">
        <div class="list" v-for="(item, index) in unpaidList" :key="index">
          <img class="cover" :src="item.image" alt="">
          <div class="des">
            <div class="row">
              <p class="bookName">{{item.name}}</p>
              <p class="price">￥{{item.price}}</p>
            </div>
            <p class="intro">简介：{{item.intro}}</p>
          </div>
          <span class="delete" @click="deleteUnpaidGoods(index)"></span>
        </div>
      </div>
    </template>
    <div class="footer">
      <div class="left">
        <div class="icon"><p class="num" v-show="unpaidList.length !== 0">{{unpaidList.length}}</p></div>
        <p class="price">总付款：<span class="color">￥{{pay_amount == 0 ? '0.00' : pay_amount}}</span></p>
      </div>
      <div class="pay open" @click="openBox('showHint')">开箱</div>
      <div :class="['pay', { disabled: isScanCodePage }]" @click="goPay('check')">支付</div>
    </div>

    <!-- 弹窗 -->
    <!-- 预定商品未选购提示 -->
    <Dialog class="dialog" :visible.sync="notSelectVisible">
      <template slot="body">
        <p class="text">您预约的商品未被选购<br/>是否要进行支付？</p>
        <div class="dialog-footer">
          <p class="footer-btn" @click="goPay">确认支付</p>
          <p class="footer-btn" @click="notSelectVisible = false">继续选购</p>
        </div>
      </template>
    </Dialog>
    <!-- 拿了其他用户预定商品提示 -->
    <Dialog class="dialog selectOther" :visible.sync="selectOtherVisible">
      <template slot="body">
        <p class="text">该商品已别其他人预定<br/>请归还到原来的位置</p>
        <p class="btn-good" @click="selectOtherVisible = false">好的</p>
      </template>
    </Dialog>
    <!-- 关箱门提示 -->
    <Dialog class="dialog closeBox" :visible.sync="closeVisible">
      <template slot="body">
        <p class="text">请关闭箱门后再进行支付操作</p>
        <p class="btn-good" @click="closeVisible = false">好的</p>
      </template>
    </Dialog>

    <!-- mqtt  -->
    <Mqttws ref="mqttws" :topic="topic" msgIsHex @getMessage="getMessage"></Mqttws>
  </div>
</template>

<script>
  import Dialog from '@/components/Bookcase/Common/Dialog'
  import Mqttws from '@/components/Bookcase/Common/Mqttws'
  import { messageError, messageSuccess, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { checkData, hex_to_ten, hexCharCodeToStr } from '../../../../static/js/utils/util'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
  import { showToast } from '../../../../static/turnoverCabinet/js/utility'
  
  let vm

  export default {
    name:'BookcaseBScanCode',
    components: {
      Mqttws,
      Dialog
    },
    computed: {
      // 当前是否是扫描条码页
      isScanCodePage () {
        return this.$route.name === 'BookcaseBScanCode'
      },
    },
    data() {
      return {
        topic: '/'+ config.deviceId + '/report/' + config.serverPort2 + '/environment/protocol',  // 硬件扫码枪主动上报主题
        topic2: '/'+ config.deviceId + '/report/' + config.serverPort2 + '/environment/protocol', // 锁状态上报订阅主题

        hasReserveList: this.$store.state.ECMall_pageSource == 'MyReserve',
        // hasReserveList: true,
        reserveList: [],  // 预定商品列表
        // reserveList: [
        //   {
        //     pid: 1
        //   },
        //   {
        //     pid: 2
        //   },
        // ],  // 预定商品列表

        unpaidList: [],  // 待支付列表
        
        pids: [],   //待支付商品id
        pay_amount: 0,  // 支付总金额
        lockStatus: '',  // 锁状态 


        // 弹窗
        notSelectVisible: false,

        selectOtherVisible: false,

        closeVisible: false

      }
    },
    created() {
      vm = this
      // 初始化预警信息(买书未扫未支付1, 买书支付码未支付2)
      vm.$store.state.ECMall_warningData = {
        user_id: vm.$store.state.eUserInfo.user_id,
        type: 1,
        pid: vm.$store.state.ECMall_activeGoods.pid
      }
      if (vm.hasReserveList) { vm.getUserProduct() }
    },
    mounted () {
      console.log('tag', this.$route)
    },
    methods: {
      // 获取我的预定商品
      async getUserProduct () {
        let data = {
          cabinet_id: config.deviceId,
          type: 2
        }

        let res = await ECMallApi.getUserProduct(data)
        if(res.meta.code === 200) {
          vm.reserveList = [...res.data]
        }  else {
          messageError(res.meta.message)
        }
      },
      // 开箱（买书开箱取物为3）
      async openBox (showHint) {
        let data = {
          type: 3,
          cabinet_id: config.deviceId,
          pid: vm.$store.state.ECMall_activeGoods.pid
        }

        console.log(data)
        if (showHint) { showLoading('正在开箱') }
        let res = await ECMallApi.openBox(data)
        if (showHint) { hideLoading() }
        if (res.meta.code === 200) {
          // console.log(res)
          console.log('开箱成功', '')
          if (showHint) { showToast('开箱成功') }
        } else {
          // messageError(res.meta.message)
          messageError('开箱失败,请点击右下方按钮联系客服')
        }
      },

      // 获取mqtt信息
      getMessage (data) {
        console.log('mqtt返回信息：', data)
        if (data) {
          vm.processData(data)
        }
      },
      // 数据处理
      processData (data) {
        // console.log('data', data, data.length)
        let dataLen = data.length
        let str = data.substring(2,dataLen-2);//截取字符串的第二到倒数第二的数据
        let num = checkData(str)
        let bbc = data.substr(dataLen-2)
        // 校验bbc是否正确
        if (num == bbc) {
          let dataType = data.substring(4,6)  // 数据流
          let func = data.substring(28, 32)   // 功能码
          let dlen = hex_to_ten(data.substring(32, 36)) // 有效数据长度
          // console.log('dataType', dataType)
          // console.log('数据长度', dlen)
          // 接收到的上报商品二维码信息
          if (dataType == 'ab' && func == 'ab01') {
            let code = hexCharCodeToStr(data.substring(36, dataLen-2))
            console.log('code', code)
            let pid = code.substr(10)
            console.log('pid获取：：：：：', pid)
            let unpaidList = [...vm.unpaidList]
            if (unpaidList.length > 0 ) {
              let isPush = true
              unpaidList.forEach(function (item, index) {
                if (item.pid == pid) {
                  isPush  = false
                  showToast('您已选购该商品，请勿重复扫码')
                  return
                }
              })
              if (isPush) { vm.scanQrcode(code)} 
            } else {
              vm.scanQrcode(code)
            }
          } 
          // 获取锁状态
          else if (dataType == 'ab' && func == 'e501') {
            // 锁状态（aa表示锁为关闭状态，55表示锁开状态）、锁编号
            let status = data.substring(data.length-4, data.length-2)
            let lockNum = data.substring(data.length-6, data.length-4)
            // console.log('status', status)
            // 锁已关闭
            if (status === 'aa') {
              vm.lockStatus = '已关'
            // 锁开状态
            } else {
              vm.lockStatus = '已开'
            }
          }
        }
      },
      // 扫描二维码获取产品信息
	    async scanQrcode (code) {
        let res = await ECMallApi.scanQrcode({ code })
        if (res.meta.code === 200) {
          let unpaidList = [...vm.unpaidList]
          console.log('unpaidList前', unpaidList)
          // 获取待支付商品列表
          if (unpaidList.length == 0) {
            vm.$refs.mqttws.onConnect(vm.topic2)
            vm.$router.push('/Bookcase/PayList')
          }
          unpaidList.push(res.data)
          console.log('unpaidList后', unpaidList)
          vm.unpaidList = unpaidList
        // 拿了其他用户已经选购的商品，提示用户放回
        } else if (res.meta.code === 300) {
          vm.selectOtherVisible = true
          vm.openBox()
        } else {
          messageError(res.meta.message)
        }
      },
      // 删除待支付商品
      deleteUnpaidGoods (index) {
        // console.log('index', index)
        vm.unpaidList.splice(index, 1)
        if (vm.unpaidList.length == 0) {
          vm.$router.go(-1)
        }
      },
      // 去支付
      goPay (check) {
        if (vm.isScanCodePage) { return }
        // 如果存在预定列表，进行校验
        if (vm.hasReserveList && check == 'check') {
          console.log('vm.checkhasReserve()', vm.checkhasReserve())
          if (!vm.checkhasReserve()) {
            vm.notSelectVisible = !vm.checkhasReserve()
            return
          }
        }
        // 先提示用户关闭箱门再支付
        if (vm.lockStatus != '已关') { 
          vm.closeVisible = vm.lockStatus != '已关'
          return
        }
        

        vm.addOrder()
      },
      // 检验预定商品是否都有选购
      checkhasReserve () {
        let unpaidList = [...vm.unpaidList]
        let reserveList = [...vm.reserveList]
        // 初始预定商品都有选购
        let hasReserve = false
        let rev = (ii)=>{
          unpaidList.forEach((item, index) => {
            let rItem =  reserveList[ii]
            if (item.pid == rItem.pid) {
              hasReserve = true
            }
            if (ii < reserveList.length-1) { rev(ii+1) }
          })
        }
        rev(0)
        return hasReserve
        // console.log('hasReserve', hasReserve)
      },
      // 添加支付订单
      async addOrder () {
        let data = {
          cabinet_id: config.deviceId,
          pids: vm.pids,
          amount: vm.pay_amount,
          desc: ''
        }

        showLoading('生成订单中')
        let res = await ECMallApi.addOrder(data)
        hideLoading()
        if (res.meta.code === 200) {
          // 清除预警信息
          vm.$store.state.ECMall_warningData = {}
          let {total_fee, order_id} = res.data
          vm.$router.push('/Bookcase/Pay/'+order_id+'/'+total_fee)
        } else {
          messageError(res.meta.message)
        }
      }
    },
    watch: {
      // 计算总金额、pids
      'unpaidList' (newVal) {
        // console.log('newVal', newVal)
        let unpaidList = newVal
        // 计算金额
        let pay_amount = 0, pids= []
        unpaidList.forEach(function (item, index) {
          pids.push(item.pid)
          let price = item.price * 100
          pay_amount += price
        })
        vm.pids = pids
        vm.pay_amount = pay_amount/100
        // console.log('pay_amount', vm.pay_amount, vm.pids)
      }
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseBScanCode {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    // 标题
    .list-tit {
      flex-shrink: 0;
      width: 100%;
      margin: 0.3rem 0;
      padding-left: 0.66rem;
      font-size: 0.3rem;
      line-height: 0.35rem;
      color: #666666;
      position: relative;
      &::before {
        display: block;
        content: '';
        height: 0.35rem;
        border-right: 0.05rem solid #647de6;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0.44rem;
        margin: auto; 
      }
      &.two {
        margin-top: 0.46rem;
      }
    }
    .box {
      flex-shrink: 0;
      width: 9.42rem;
      margin: 0 auto;
      padding-top: 1.3rem;
      // background-color: #ffffff;
      // box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      line-height: 1;
      text-align: center;
      display: flex;
      flex-direction: column;
      .icon {
        display: block;
        width: 1.15rem;
        height: 1.02rem;
        margin: 0 auto;
      }
      .text {
        flex-shrink: 0;
        margin: 0.5rem 0 0.19rem;
        color: #999999;
        font-size: 0.28rem;
      }
      .hint {
        width: 4.5rem;
        margin: 0 auto;
        font-size: 0.3rem;
        line-height: 0.4rem;
        font-weight: bold;
        text-align: center;
        color: #999999;
      }
    }
    .reserve-wrapper {
      flex-shrink: 0;
      width: 100%;
      padding-bottom: 0.44rem;
      background-color: #dedede;
      .reserve-box {
        width: 100%;
        height: 2.72rem;
        padding-left: 0.43rem;
        overflow-x: scroll;
        overflow-y: hidden;
        display: flex;
        &::-webkit-scrollbar{
          display: none;
        }
        .list {
          flex-shrink: 0;
          width: 1.82rem;
          height: inherit;
          line-height: 1;
          margin-right: 0.4rem;
          text-align: center;
          border-radius: 0.05rem;
          background-color: #ffffff;
          display: block;
          flex-direction: column;
          .cover {
            width: 1.35rem;
            height: 1.8rem;
            margin-top: 0.19rem;
          }
          .bookname {
            font-size: 0.2rem;
            font-weight: bold;
            color: #333333;
            margin: 0.14rem auto 0.11rem;
            max-width: 1.12rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .num {
            font-size: 0.18rem;
            color: #666666;
          }
        }
      }
    }
    .list-wrapper {
      width: 100%;
      height: 100%;
      // height: calc(100% - 0.95rem - 1.42rem - 0.3rem);
      margin-bottom: 1.72rem;
      padding:  0 0.41rem 0 0.47rem;
      overflow-x: hidden;
      overflow-y: scroll;
      .list {
        width: 100%;
        height: 2.15rem;
        margin-bottom: 0.3rem;
        padding: 0.18rem 0.96rem 0.17rem 0.38rem;
        background-color: #ffffff;
        box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
        display: flex;
        position: relative;
        &:last-child {
          margin-bottom: 0;
        }
        .cover {
          flex-shrink: 0;
          width: 1.35rem;
          height: 1.8rem;
          margin-right: 0.35rem;
        }
        .des {
          width: 100%;
          .row {
            margin: 0.35rem 0;
            font-size: 0.34rem;
            line-height: 1em;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            .bookName {
            }
            .price {
              color: #d72f2f;
            }
          }
          .intro {
            height: 0.64rem;
            font-size: 0.24rem;
            line-height: 0.32rem;
            color: #999999;
            // position: relative;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
            text-overflow: ellipsis;
            // &::after{
            //   content: "...";
            //   position: absolute; 
            //   bottom: 0; 
            //   right: 0; 
            //   padding-left: 0.5em;
            //   background: -webkit-linear-gradient(left, transparent, #fff 55%);
            //   background: -o-linear-gradient(right, transparent, #fff 55%);
            //   background: -moz-linear-gradient(right, transparent, #fff 55%);
            //   background: linear-gradient(to right, transparent, #fff 55%);
            // }
          }
        }
        .delete {
          width: 0.65rem;
          height: 0.65rem;
          background: url(/static/Bookcase/images/icon_delete.png) center no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
    .footer {
      width: 100%;
      height: 1.42rem;
      box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      display: flex;
      position: absolute;
      bottom: 0;
      left: 0;
      // z-index: 99;
      .left {
        flex-shrink: 0;
        width: 5.7rem;
        background-color: #ffffff;
        display: flex;
        .icon {
          width: 1.01rem;
          height: 0.99rem;
          margin: 0.2rem 0.28rem 0 0.51rem;
          background: url(/static/Bookcase/images/icon_book2.png) center no-repeat;
          background-size: 100% 100%;
          position: relative;
          .num {
            width: 0.46rem;
            height: 0.46rem;
            line-height: 0.46rem;
            font-size: 0.3rem;
            font-weight: bold;
            text-align: center;
            border-radius: 50%;
            color: #ffffff;
            background-color: #f0532f;
            position: absolute;
            right: -0.24rem;
            top: -0.2rem;
          }
        }
        .price {
          margin-top: 0.6rem;
          font-size: 0.35rem;
          line-height: 1em;
          color: #333333;
          .color {
            font-size: 0.45rem;
            color: #ff3838;
          }
        }
      }
      .pay {
        flex-shrink: 0;
        width: 2.3rem;
        font-size: 0.48rem;
        line-height: 1.42rem;
        text-align: center;
        color: #ffffff;
        background-color: #f0532f;
        &.disabled {
          background-color: #c5c5c5;
        }
        &.open {
          background-color: #f3ae3e;
        }
      }
    }
    .dialog {
      &.selectOther .text {
        margin-top: 1rem;
      }
      &.closeBox .text {
        max-width: 100%;
      }
      .btn-good {
        width: 2.63rem;
        height: 0.73rem;
        line-height: 0.73rem;
        margin-top: 0.9rem;
        color: #ffffff;
        text-align: center;
        font-size: 0.4rem;
        border-radius: 0.05rem;
        font-weight: bold;
        background-color: #647de6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Buy/Paylist.vue